'use client';

import { Button } from '@/components/ui/button';
// import { deleteGolfProfile } from '@/utils/actions'; // Import the delete function
import { useTranslation } from 'react-i18next';
import { useAppNavigation } from '@/lib/i18nNavigation';
import { useState } from 'react';
import ConfirmationDialog from './ConfirmationDialog';

const DeleteProfile = () => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const { navigate } = useAppNavigation();
  const { t } = useTranslation();
  const handleDeleteProfile = async () => {
    try {
      // await deleteGolfProfile(userProfile.id); // Call the delete function with the profile ID
      navigate('/'); // Redirect to the root path
    } catch (error) {
      console.error('Error deleting profile:', error);
    } finally {
      setConfirmationDialogOpen(false); // Close the confirmation dialog
    }
  };

  return (
    <>
      <Button variant="destructive" onClick={() => setConfirmationDialogOpen(true)}>
        {t('delete_account')}
      </Button>

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        onConfirm={handleDeleteProfile}
        title={t('delete_account')}
        description={t('delete_account_warning_caption')}
        confirmText={t('delete')}
        cancelText={t('cancel')}
        level="destructive"
        delayAction
      />
    </>
  );
};

export default DeleteProfile;
